<template>
    <UiProductMap v-editable="blok" :blok="blok" class="ui-product-map" />
</template>

<script setup lang="ts">
defineProps({ blok: { type: Object } });
</script>

<style lang="postcss" scoped>
.ui-product-map.product-map :deep(.map-btn:not(.map-active) button) {
    @apply bg-primary hover:bg-secondary;
}
.ui-product-map.product-map :deep(.map-btn.map-active button) {
    @apply bg-white border text-primary border-primary hover:bg-primary hover:text-white;
}
</style>
